const SET_ITEMS = "SET_ITEMS";
const SET_TOTAL_ITEMS = "SET_TOTAL_ITEMS";
const SET_OPTIONS = "SET_OPTIONS";
const SET_SEARCH = "SET_SEARCH";
const SET_LOADER = "SET_LOADER";
const CLEAR_ITEMS = "CLEAR_ITEMS";
const RESET_DATA_TABLE = "RESET_DATA_TABLE";

const initialState = {
  items: [],
  totalItems: 0,
  options: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ["created_at"],
    sortDesc: [true]
  },
  search: "",
  loader: false,
  footerProps: { "items-per-page-options": [10, 15, 20, 25, 50] }
};

const actions = {
  setItems({ commit }, items) {
    commit("SET_ITEMS", items);
  },
  setTotalItems({ commit }, totalItems) {
    commit("SET_TOTAL_ITEMS", totalItems);
  },
  setOptions({ state, commit }, options) {
    if (state.options === options) return;
    commit("SET_OPTIONS", options);
  },
  setSearch({ state, commit, dispatch }, search) {
    if (state.search === search) return;

    try {
      if (search.length > 0 && search.length < 3)
        throw "A busca deve conter no mínimo 3 caracteres!";
      commit("SET_SEARCH", search);
      dispatch("getItems");
    } catch (e) {
      throw e;
    }
  },
  startLoader({ commit }) {
    commit("SET_LOADER", true);
  },
  stopLoader({ commit }) {
    commit("SET_LOADER", false);
  },
  clearItems({ commit }) {
    commit("CLEAR_ITEMS");
  },
  resetDataTable({ commit }) {
    commit("RESET_DATA_TABLE");
  }
};

const mutations = {
  [SET_ITEMS](state, items) {
    state.items = items;
  },
  [SET_TOTAL_ITEMS](state, totalItems) {
    state.totalItems = totalItems;
  },
  [SET_OPTIONS](state, options) {
    state.options = options;
  },
  [SET_SEARCH](state, search) {
    state.search = search;
  },
  [SET_LOADER](state, loader) {
    state.loader = loader;
  },
  [CLEAR_ITEMS](state) {
    state.items = [];
    state.totalItems = 0;
  },
  [RESET_DATA_TABLE](state) {
    Object.assign(state, initialState);
  }
};

const getters = {};

export default {
  state: initialState,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/creators/dataTable.js